import React from 'react';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { Form } from 'react-bootstrap';

import { FormGroupText, FormButton } from '../../../shared/ui';

const defaultInitialValues = {
  title: '',
  value: '',
};

const validationSchema = yup.object().shape({
  title: yup.string().required('Title is a required field'),
  value: yup.string().required('Value is a required field'),
});

interface Params {
  onSubmit: (values: any) => void;
  initialValues?: { title: string; value: string };
}

function SettingsFormLayout(params: Params) {
  const form = useFormik({
    initialValues: params.initialValues || defaultInitialValues,
    validationSchema,
    onSubmit: params.onSubmit,
  });

  return (
    <Form noValidate onSubmit={form.handleSubmit}>
      <FormGroupText field="title" form={form} />

      <FormGroupText field="value" form={form} />

      <br />
      <FormButton type="submit" form={form} disabled={!form.dirty || !form.isValid}>
        Submit
      </FormButton>
    </Form>
  );
}

export { SettingsFormLayout };
